const getPieveRuntimeInstanceHeader = () => {
  if (typeof window !== 'undefined' && window?.pieve?.apiVersion) {
    return 'pieve-desktop';
  }

  return 'pieve-web';
};

export default getPieveRuntimeInstanceHeader;
